module.exports = __webpack_public_path__ + "img/login4.e51427e2.png";